import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../app/store';
import { signOut } from '../../app/sessionSlice';
import { ROUTES } from '../../app/routes';

/**
 * `/logout`: the sign-out entry product apps (Restaurant, Cosmetics…) redirect to. Platform owns the
 * session, so a product's "Log out" lands here, Platform revokes its refresh token and customer SSO,
 * then shows the sign-in page.
 */
export function LogoutPage(): null {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    void dispatch(signOut()).finally(() => { if (active) navigate(ROUTES.login, { replace: true }); });
    return () => { active = false; };
  }, [dispatch, navigate]);
  return null;
}
